import React, { useState } from "react";
import './formManagementAreas.css'
import { Input, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const FormManagementAreas = ({ addManagementArea }) => {
    const [inputValue, setInputValue] = useState("");

    const handleAdd = () => {
        if (inputValue.trim()) {
            addManagementArea(inputValue);
            setInputValue(""); // Limpiar el input después de agregar
        }
    };

    return (
        <div style={{ display: "flex", gap: "8px", alignItems: "center", width: "100%" }}>
            <Input
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder="Añadir gerencia"
            />
            <Button type="primary" onClick={handleAdd} icon={<PlusOutlined />}>
                Agregar
            </Button>
        </div>
    );
};

export default FormManagementAreas;
